module.exports = __webpack_public_path__ + "images/b2f5a9088c01209f7a7f5f5982ad1c16.png";